import { Box } from '@mui/material'
import { SelectChangeEvent } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import React, { useState } from 'react'
import useSWR from 'swr'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { SubmitHandler, useForm, Controller } from 'react-hook-form'
import { countries, ICountries } from '~/src/constants'
import { otherRepository } from '~/src/repositories'
import { HeaderSearchTextField } from '~/src/components/molecules/Search/HeaderSearchTextField/HeaderSearchTextField'
import { HeaderSearchButton } from '~/src/components/molecules/Search/HeaderSearchButton/HeaderSearchButton'
import { HeaderSearchSelect } from '~/src/components/molecules/Search/HeaderSearchSelect/HeaderSearchSelect'
import { ExportCsvButton } from '~/src/components/molecules/ExportCsvButton/ExportCsvButton'

interface IGetUserParams {
  offset?: number
  limit?: number
  countryId?: string
  email?: string
  name?: string
  loadingPortId?: string
}
interface UserFormParams {
  country?: string
  email?: string
  name?: string
  loadingPort?: string
}

interface IHeaderMemberProps {
  onSubmit: (_params?: IGetUserParams) => void
  params: IGetUserParams
}

export const HeaderMember: React.FC<IHeaderMemberProps> = ({ onSubmit, params }): JSX.Element => {
  const { t } = useTranslation()
  const { control, register, handleSubmit } = useForm<UserFormParams>()
  const location = useLocation()

  // @ts-ignore
  const [country, setCountry] = useState<string>(location.state?.countryId || '')
  // @ts-ignore
  const [loadingPort, setLoadingPort] = useState<string>(location.state?.loadingPortId || '')

  const { data: loadingPorts } = useSWR(['/loading-ports'], () =>
    otherRepository.getLoadingPorts(),
    {
      fallbackData: [],
    }
  )

  const handleCountryChange = (event: SelectChangeEvent) => {
    setCountry(event.target.value as string)
  }

  const handleLoadingPortChange = (event: SelectChangeEvent) => {
    setLoadingPort(event.target.value as string)
  }

  const submit: SubmitHandler<UserFormParams> = (input) => {
    onSubmit({ countryId: country, email: input.email, name: input.name, loadingPortId: loadingPort })
  }

  return (
    <form onSubmit={handleSubmit(submit)}>
      <Box display={'flex'} justifyContent={'space-between'} sx={{ mb: '36px' }}>
        <Box display={'flex'} alignItems={'center'}>
          <HeaderSearchSelect
            label={`${t('list_member.country')}`}
            value={country}
            onChange={handleCountryChange}
            optionsComponents={countries.map((country: ICountries, index: number) => (
              <MenuItem key={index} value={country.id}>
                {country.name}
              </MenuItem>
            ))}
          />
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <HeaderSearchTextField
                placeholder={t('list_member.email')}
                {...register('email')}
                {...field}
              />
            )}
          />
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <HeaderSearchTextField
                placeholder={t('list_member.name')}
                {...register('name')}
                {...field}
              />
            )}
          />
          <HeaderSearchSelect
            label={`${t('list_member.loading_port')}`}
            value={loadingPort}
            onChange={handleLoadingPortChange}
            optionsComponents={loadingPorts.map((port, index: number) => (
              <MenuItem key={index} value={port.id}>
                {port.name}
              </MenuItem>
            ))}
          />
          <HeaderSearchButton buttonText={t('list_member.search')} />
        </Box>
        <ExportCsvButton exportCsvKey={'user'} params={params} />
      </Box>
    </form>
  )
}
